module.exports = __webpack_public_path__ + "wordmark.909fe701.svg";